let audioLabelsPromise = null;

export const ensureAudioDeviceLabels = () => {
	if (!audioLabelsPromise) {
		audioLabelsPromise = navigator.mediaDevices
			? navigator.mediaDevices.getUserMedia({ audio: true })
				.then(stream => stream.getTracks().forEach(track => track.stop()))
				.catch(() => {})
			: Promise.resolve();
	}

	return audioLabelsPromise;
};

const FRONT_LABEL = /front|frontal|user/i;

const BACK_LABEL = /back|rear|environment|traseira/i;

const facingOf = device => {
	try {
		const modes = device.getCapabilities ? device.getCapabilities().facingMode || [] : [];

		if (modes.includes('user')) {
			return 'front';
		}

		if (modes.includes('environment')) {
			return 'back';
		}
	} catch (error) { }

	if (FRONT_LABEL.test(device.label)) {
		return 'front';
	}

	return BACK_LABEL.test(device.label) ? 'back' : null;
};

const plainestOf = devices => devices.reduce(
	(shortest, device) => (device.label.length < shortest.label.length ? device : shortest),
	devices[0]
);

export const simplifyCameraDevices = devices => {
	const front = devices.filter(device => facingOf(device) === 'front');
	const back = devices.filter(device => facingOf(device) === 'back');

	if (front.length === 0 || back.length === 0) {
		return devices;
	}

	return [
		{ deviceId: plainestOf(front).deviceId, label: 'Câmera frontal' },
		{ deviceId: plainestOf(back).deviceId, label: 'Câmera traseira' }
	];
};

export const isFrontFacingDevice = (devices, deviceId) => {
	const active = devices.find(device => device.deviceId === deviceId);

	return active ? facingOf(active) !== 'back' : true;
};
